export enum DocumentationStatus {
   'Not Started',
   'Pending Approval',
   'Tasks Complete',
   'Steps Complete',
   'Approved',
   'Needs Revision',
}
